(function() {
  /**
   * Media Queries
   * These should be adjusted to match the CSS
   */
  var BRK_MOBILEONLY = '(max-width: 767px)';
  var BRK_TABLET = '(min-width: 768px)';
  var BRK_TABLETLANDSCAPE = '(min-width: 1024px)';
  var BRK_DESKTOP = '(min-width: 1200px)';
  var BRK_FULLSIZE = '(min-width: 1400px)';

  if(window.matchMedia) {
    var MQ_MOBILEONLY = window.matchMedia(BRK_MOBILEONLY);
    var MQ_TABLET = window.matchMedia(BRK_TABLET);
    var MQ_TABLETLANDSCAPE = window.matchMedia(BRK_TABLETLANDSCAPE);
    var MQ_DESKTOP = window.matchMedia(BRK_DESKTOP);
    var MQ_FULLSIZE = window.matchMedia(BRK_FULLSIZE);

    /**
      * Event Functions
      */
    function handleBreakpointChange() {
      window.currentBreakpoint = [];
      if(MQ_MOBILEONLY.matches) {
        window.currentBreakpoint.push('mobile');
        window.dispatchEvent(new CustomEvent('breakpoint-mobile', { detail: window.innerWidth }));
      }
      if(MQ_TABLET.matches) {
        window.currentBreakpoint.push('tablet');
        window.dispatchEvent(new CustomEvent('breakpoint-tablet', { detail: window.innerWidth }));
      }
      if(MQ_TABLETLANDSCAPE.matches) {
        window.currentBreakpoint.push('tabletlandscape');
        window.dispatchEvent(new CustomEvent('breakpoint-tabletlandscape', { detail: window.innerWidth }));
      }
      if(MQ_DESKTOP.matches) {
        window.currentBreakpoint.push('desktop');
        window.dispatchEvent(new CustomEvent('breakpoint-desktop', { detail: window.innerWidth }));
      }
      if(MQ_FULLSIZE.matches) {
        window.currentBreakpoint.push('fullsize');
        window.dispatchEvent(new CustomEvent('breakpoint-fullsize', { detail: window.innerWidth }));
      }
    }

    MQ_MOBILEONLY.addListener(handleBreakpointChange);
    // Don't need to add this one, since it's handled by the mobile breakpoint event handler
    // The handler fires when the media query no longer matches, so it will fire
    // when tablet becomes active too.
    // MQ_TABLET.addListener(handleBreakpointChange);
    MQ_TABLETLANDSCAPE.addListener(handleBreakpointChange);
    MQ_DESKTOP.addListener(handleBreakpointChange);
    MQ_FULLSIZE.addListener(handleBreakpointChange);
    handleBreakpointChange();
  }
})();